export default "__VITE_ASSET__DR1DK3n9__"